const ContentCurationList = (props) =>
  <ul class='topic-curation__list list'>
    {props.children}
  </ul>

export default ContentCurationList
